import script from "./TermosDeSaque.vue?vue&type=script&setup=true&lang=js"
export * from "./TermosDeSaque.vue?vue&type=script&setup=true&lang=js"

import "./TermosDeSaque.vue?vue&type=style&index=0&id=62a13568&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a13568"]])

export default __exports__